import AddButtonComponent, {
  AddButtonComponentProps,
} from './AddButtonComponent';

export default AddButtonComponent;

export type { AddButtonComponentProps };
